import { Pipe, PipeTransform } from '@angular/core';
import { MessageDirection } from '../../conversations/contracts/conversation.interface';
import { TenantSettings } from '../../tenants/contracts/tenant_settings.interface';

@Pipe({
  name: 'TakingLong',
  pure: false
})
export class TakingLongPipe implements PipeTransform {

  transform(conversation: any): boolean {
    if (!conversation) return false;

    const lastMessageDirection = conversation.lastMessageDirection;
    const lastMessageUpdatedAt = new Date(conversation.lastMessageUpdatedAt || conversation.updateTime);

    if (!lastMessageDirection || !lastMessageUpdatedAt) return false;
    if (lastMessageDirection !== MessageDirection.INCOMING) return false;

    const raw = localStorage.getItem('tenantSettings');
    if (!raw) return false;

    let alertMinutes: number | null = null;

    try {
      const settings: TenantSettings = JSON.parse(raw);
      const alert = settings?.features?.alertTimer;

      if (!alert?.enabled || alert.minutes == null) return false;

      alertMinutes = alert.minutes;
    } catch (e) {
      console.error('Errore parsing tenantSettings da localStorage', e);
      return false;
    }

    const now = new Date();
    const diffMs = now.getTime() - lastMessageUpdatedAt.getTime();
    const diffMinutes = diffMs / 1000 / 60;

    return diffMinutes > alertMinutes;
  }
}
